import { z } from 'zod';
import { SweetShopArticleCategoryTagModelSchema } from 'entities/sweet-shop-article-category-tag';
import { GetSweetShopArticleCategoryTagsByCategoryUidApiResponseSchema } from '../store';

// eslint-disable-next-line max-len
export const createSweetShopArticleCategoryTagsFromGetSweetShopArticleCategoryTagsByCategoryUidApiResponse = (
    (response: z.infer< typeof GetSweetShopArticleCategoryTagsByCategoryUidApiResponseSchema>) => (
        response.data?.map(({
            slug,
            name,
            category,
        }) => (
            SweetShopArticleCategoryTagModelSchema.parse({
                uid: slug,
                name,
                category: category && {
                    uid: category.slug,
                },
            })
        ))
    )
);
